import React from 'react';
import AdminMarkdownDoc from '@/modules/admin/components/AdminMarkdownDoc';
import devGuideMarkdown from '../../../../docs/connecting-to-app-guide.md?raw';

export default function AdminAppDevGuidePage() {
  return (
    <AdminMarkdownDoc
      icon="📖"
      title="Connecting to an App"
      description="For integrators: how to connect your app (CRM, dashboard, etc.) to this app via links and the API"
      markdown={devGuideMarkdown}
    />
  );
}
